import { render, staticRenderFns } from "./EmailMessage.vue?vue&type=template&id=370de90b&scoped=true"
import script from "./EmailMessage.vue?vue&type=script&lang=ts"
export * from "./EmailMessage.vue?vue&type=script&lang=ts"
import style0 from "./EmailMessage.vue?vue&type=style&index=0&id=370de90b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370de90b",
  null
  
)

export default component.exports